import posthog from 'posthog-js'
import { useQueryClient } from '@tanstack/react-query'
import { signOut } from '@/lib/auth-client'
import { clearTabOrganization } from '@/lib/tab-organization'

const LOGIN_PATH = '/login'

export function useLogout() {
  const queryClient = useQueryClient()

  const logout = async () => {
    try {
      posthog.reset()
      queryClient.clear()
      await signOut()
    } catch (error) {
      console.error('Error during logout:', error)
    } finally {
      clearTabOrganization({ untilReload: true })
      window.location.assign(LOGIN_PATH)
    }
  }

  return { logout }
}
